import { constants, findPermission, getStorage } from 'helpers'
import { useNetworkConnection } from 'hooks/useNetworkConnection'

export const useMobilePayment = () => {
    const { isOnline, isSlowNetwork } = useNetworkConnection()
    const userPermissions = getStorage(constants.USER_PERMISSIONS)
    const countryConfig = getStorage(constants.COUNTRY_CONFIG)

    const mobilePaymentProviders = countryConfig?.mobile_payments || []

    const canMakeMobilePayment =
        findPermission(userPermissions, constants.CAN_MAKE_MOBILE_PAYMENT) ||
        false

    const hasMobilePaymentProviders = mobilePaymentProviders?.length > 0
    const isMobilePaymentEnabled =
        canMakeMobilePayment &&
        hasMobilePaymentProviders &&
        isOnline &&
        !isSlowNetwork

    return {
        isMobilePaymentEnabled,
        mobilePaymentProviders
    }
}
